<template>
  <div>
    <div 
      class="card card--vdo" 
      @click="openVideoModal" 
      :style="{ backgroundImage: `url('${image}')` }"
    >
      <div class="card__title" v-html="title"></div>
    </div>
    <VideoPopup v-model="isVideoModalOpen" :src="src" :poster="poster"/>
  </div>
</template>

<script setup>
import VideoPopup from '@/components/apps/VideoPopup.vue'
import { ref } from 'vue'

const props = defineProps({
  src: { type: String, required: true },
  image: { type: String, default: '' },
  poster: { type: String, default: '' },
  title: { type: String, default: '' }
});

const isVideoModalOpen = ref(false)
const openVideoModal = () => {
  isVideoModalOpen.value = true
}
</script>